import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/LoginPage';
import AuthCallback from '@/pages/AuthCallback';
import DashboardPage from '@/pages/DashboardPage';
import BiotechCompaniesPage from '@/pages/BiotechCompaniesPage';
import BiotechContactsPage from '@/pages/BiotechContactsPage';
import PharmaContactsPage from '@/pages/PharmaContactsPage';
import DedupePharmaContactsPage from '@/pages/DedupePharmaContactsPage';
import PharmaContactDetailPage from '@/pages/PharmaContactDetailPage';
import DealPipelinePage from '@/pages/DealPipelinePage';
import FinancialsPage from '@/pages/FinancialsPage';
import OutreachPage from '@/pages/OutreachPage';
import DistributorRecoveryPage from '@/pages/DistributorRecoveryPage';
import ClassificationVerifyPage from '@/pages/ClassificationVerifyPage';
import AIMappingPage from '@/pages/AIMappingPage';
import AbacusShortlistPage from '@/pages/AbacusShortlistPage';
import AlertsPage from '@/pages/AlertsPage';
import IntelligenceHubPage from '@/pages/IntelligenceHubPage';
import CopilotPage from '@/pages/CopilotPage';
import OpportunityListsPage from '@/pages/OpportunityListsPage';
import CampaignsPage from '@/pages/CampaignsPage';
import CompanyDetailPage from '@/pages/CompanyDetailPage';
import CompanyProfilesPage from '@/pages/CompanyProfilesPage';
import CompanyProfileDetailPage from '@/pages/CompanyProfileDetailPage';
import PublicStatusPage from '@/pages/PublicStatusPage';
import PublicContactMatchesPage from '@/pages/public/PublicContactMatchesPage';
import PublicILStatusPage from '@/pages/PublicILStatusPage';
import AssetsPage from '@/pages/AssetsPage';
import EmailTrackingPage from '@/pages/EmailTrackingPage';
import SiteAnalyticsPage from '@/pages/SiteAnalyticsPage';
import GmailPage from '@/pages/GmailPage';
import OutreachStatusPage from '@/pages/OutreachStatusPage';
import FollowUpsPage from '@/pages/FollowUpsPage';
import FollowUpComposerPage from '@/pages/FollowUpComposerPage';
import MetInPersonPage from '@/pages/MetInPersonPage';
import WeeklyDigestPage from '@/pages/WeeklyDigestPage';
import RegionalDistributorsPage from '@/pages/RegionalDistributorsPage';
import PortfolioMatchPage from '@/pages/PortfolioMatchPage';
import AccountsPage from '@/pages/AccountsPage';
import AccountDetailPage from '@/pages/AccountDetailPage';
import EngagementsListPage from '@/pages/EngagementsListPage';
import ViatrisWorkbenchPage from '@/pages/ViatrisWorkbenchPage';
import ReviewerWorkspace from '@/pages/ReviewerWorkspace';
import BatchErrorsPage from '@/pages/BatchErrorsPage';
import FunnelDebugPage from '@/pages/FunnelDebugPage';
import PublicEngagementPage from '@/pages/PublicEngagementPage';
import ViatrisClientDashboard from '@/pages/ViatrisClientDashboard';
import ViatrisReferenceLibraryPage from '@/pages/ViatrisReferenceLibraryPage';
import ContactMatchingPage from '@/pages/ContactMatchingPage';
import DatabaseSyncPage from '@/pages/DatabaseSyncPage';
import ConferenceImportPage from '@/pages/ConferenceImportPage';
import ImportHubPage from '@/pages/ImportHubPage';
import InboxTriagePage from '@/pages/InboxTriagePage';
import AuditPage from '@/pages/AuditPage';
import DuplicatesInspectorPage from '@/pages/DuplicatesInspectorPage';
import MergeRecoveryPage from '@/pages/MergeRecoveryPage';
import EmailCoveragePage from '@/pages/EmailCoveragePage';
import HomePage from '@/pages/public/HomePage';
import ServicesPage from '@/pages/public/ServicesPage';
import PharmaBDRetainerPage from '@/pages/public/PharmaBDRetainerPage';
import PartneringPage from '@/pages/public/PartneringPage';
import ForPharmaPage from '@/pages/public/ForPharmaPage';
import ForBiotechPage from '@/pages/public/ForBiotechPage';
import CaseStudiesPage from '@/pages/public/CaseStudiesPage';
import AboutPage from '@/pages/public/AboutPage';
import PlatformPage from '@/pages/public/PlatformPage';
import ApplyPage from '@/pages/public/ApplyPage';
import PitchDeckPage from '@/pages/public/PitchDeckPage';
import OutLicensorDeckPage from '@/pages/public/OutLicensorDeckPage';
import InLicensorDeckPage from '@/pages/public/InLicensorDeckPage';
import SharedMappingPage from '@/pages/public/SharedMappingPage';
import PublicDataRoomPage from '@/pages/PublicDataRoomPage';
import DataRoomWelcomePage from '@/pages/DataRoomWelcomePage';
import AssetImportPage from '@/pages/AssetImportPage';
import TaBackfillPage from '@/pages/TaBackfillPage';import ConsolidateOutreachPage from '@/pages/ConsolidateOutreachPage';
import ViatrisDuplicatesPage from '@/pages/ViatrisDuplicatesPage';
import TaAuditPage from '@/pages/TaAuditPage';
import ExclusionAuditPage from '@/pages/ExclusionAuditPage';
import HiddenEmailsPage from '@/pages/HiddenEmailsPage';
import EnquiriesPage from '@/pages/EnquiriesPage';
import RoaBackfillPage from '@/pages/RoaBackfillPage';
import CountryBackfillPage from '@/pages/CountryBackfillPage';
import StageBackfillPage from '@/pages/StageBackfillPage';
import StageRecoveryReportPage from '@/pages/StageRecoveryReportPage';
import OutOfScopePurgePage from '@/pages/OutOfScopePurgePage';
import ModalityBackfillPage from '@/pages/ModalityBackfillPage';
import IndicationBackfillPage from '@/pages/IndicationBackfillPage';
import AssetStandardizationPage from '@/pages/AssetStandardizationPage';
import ReviewQueuePage from '@/pages/ReviewQueuePage';
import HandshakeClassifierPage from '@/pages/HandshakeClassifierPage';
import DeepResearchBackfillPage from '@/pages/DeepResearchBackfillPage';
import StaleMappingsPage from '@/pages/StaleMappingsPage';
import DeckReenrichPage from '@/pages/DeckReenrichPage';
import SuppressedContactsPage from '@/pages/SuppressedContactsPage';
import MedTechReviewPage from '@/pages/MedTechReviewPage';
import AnimalHealthScreeningPage from '@/pages/AnimalHealthScreeningPage';
import AnimalHealthResultsPage from '@/pages/AnimalHealthResultsPage';
import AnimalHealthCohortPage from '@/pages/AnimalHealthCohortPage';
import AnimalHealthBrowsePage from '@/pages/AnimalHealthBrowsePage';
import DemoPage from '@/pages/DemoPage';
import AnalyticsPage from '@/pages/admin/AnalyticsPage';
import InvestorsPage from '@/pages/InvestorsPage';
import { RouteTracker } from '@/components/RouteTracker';
import '@/App.css';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

// Post-login landing for client-role users: resolve their engagement's
// tokenized portal URL and hard-redirect into the Viatris client portal.
function ClientPortalRedirect() {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => {
    fetch(`${API_BASE}/client/portal-entry`, { credentials: 'include' })
      .then(r => (r.ok ? r.json() : Promise.reject(r)))
      .then(d => window.location.replace(d.portal_url))
      .catch(() => setFailed(true));
  }, []);
  if (failed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="client-portal-error">
        <p className="text-sm text-slate-600 text-center max-w-sm">
          No client portal is provisioned for your account yet. Please contact your ForesightRx representative.
        </p>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="client-portal-redirect">
      <div className="w-6 h-6 border-2 border-slate-900 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-6 h-6 border-2 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Reviewers are confined to their /review workspace — they never see the
  // admin app (no toolbar, config, user mgmt, billing, unrelated clients).
  if (user.role === 'reviewer') {
    return <Navigate to="/review" replace />;
  }

  // Client-role users are confined to their designated portal only.
  //   viatris        → tokenized /client/viatris/… route  (via ClientPortalRedirect)
  //   animal-health  → /animal-health/cohort read-only + clickable Approve/Reject
  if (user.role === 'client') {
    const path = location.pathname;
    if (user.portal_type === 'animal-health' && path.startsWith('/animal-health')) {
      // Render inside a stripped-down shell — no admin sidebar, just the page.
      return (
        <div className="min-h-screen bg-slate-50" data-testid="client-animal-health-shell">
          {children}
        </div>
      );
    }
    return <ClientPortalRedirect />;
  }

  return <Layout>{children}</Layout>;
}

// Auth gate for the tokenized Viatris client portal (Jul 2026 — email-OTP
// login). Client + internal (admin/viewer) sessions may enter; reviewers
// stay confined to /review.
function ClientRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-6 h-6 border-2 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }
  if (user.role === 'reviewer') {
    return <Navigate to="/review" replace />;
  }
  return children;
}

// Standalone protected shell for the reviewer workspace — no admin Layout.
function ReviewerRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-6 h-6 border-2 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  // Admins may also open the reviewer workspace (for QA/oversight).
  if (user.role !== 'reviewer' && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
}

// Fallback for any unmatched path. Signed-in clients get bounced into
// their portal (via ClientPortalRedirect) instead of dropping onto the
// public marketing site (`/`), which would look like they'd been signed
// out. Everyone else falls through to the public HomePage.
function CatchAllRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-6 h-6 border-2 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user?.role === 'client') {
    return <ClientPortalRedirect />;
  }
  if (user?.role === 'reviewer') {
    return <Navigate to="/review" replace />;
  }
  return <Navigate to="/" replace />;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();

  // Check URL fragment or query params for session_id synchronously during render
  // This handles both /auth/callback and any other page that might have session_id
  if (location.hash?.includes('session_id=') || location.search?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Also handle the dedicated callback route
  if (location.pathname === '/auth/callback') {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public pages */}
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/pharma-bd-retainer" element={<PharmaBDRetainerPage />} />
      <Route path="/partnering" element={<PartneringPage />} />
      <Route path="/for-pharma" element={<ForPharmaPage />} />
      <Route path="/for-biotech" element={<ForBiotechPage />} />
      <Route path="/out-licensor-deck" element={<OutLicensorDeckPage />} />
      <Route path="/in-licensor-deck" element={<InLicensorDeckPage />} />
      <Route path="/case-studies" element={<CaseStudiesPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/platform" element={<PlatformPage />} />
      <Route path="/apply" element={<ApplyPage />} />
      <Route path="/pitch" element={<PitchDeckPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/status/:token" element={<PublicStatusPage />} />
      <Route path="/matches/:token" element={<PublicContactMatchesPage />} />
      <Route path="/il-status/:token" element={<PublicILStatusPage />} />
      <Route path="/engagement-status/:token" element={<PublicEngagementPage />} />
      <Route path="/client/viatris/:token" element={<ClientRoute><ViatrisClientDashboard /></ClientRoute>} />
      <Route path="/client/viatris/:token/reference" element={<ClientRoute><ViatrisReferenceLibraryPage /></ClientRoute>} />
      <Route path="/shared/mapping/:token" element={<SharedMappingPage />} />
      <Route path="/dataroom/:token" element={<PublicDataRoomPage />} />
      <Route path="/data-room-welcome" element={<DataRoomWelcomePage />} />
      <Route path="/asset-imports" element={<ProtectedRoute><AssetImportPage /></ProtectedRoute>} />
      <Route path="/data-ops/viatris-duplicates" element={<ProtectedRoute><ViatrisDuplicatesPage /></ProtectedRoute>} />
      <Route path="/data-ops/ta-backfill" element={<ProtectedRoute><TaBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/ta-audit" element={<ProtectedRoute><TaAuditPage /></ProtectedRoute>} />
      <Route path="/data-ops/exclusion-audit" element={<ProtectedRoute><ExclusionAuditPage /></ProtectedRoute>} />
      <Route path="/data-ops/hidden-emails" element={<ProtectedRoute><HiddenEmailsPage /></ProtectedRoute>} />
      <Route path="/data-ops/enquiries" element={<ProtectedRoute><EnquiriesPage /></ProtectedRoute>} />
      <Route path="/data-ops/roa-backfill" element={<ProtectedRoute><RoaBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/country-backfill" element={<ProtectedRoute><CountryBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/stage-backfill" element={<ProtectedRoute><StageBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/stage-report" element={<ProtectedRoute><StageRecoveryReportPage /></ProtectedRoute>} />
      <Route path="/data-ops/scope-purge" element={<ProtectedRoute><OutOfScopePurgePage /></ProtectedRoute>} />
      <Route path="/data-ops/modality-backfill" element={<ProtectedRoute><ModalityBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/indication-backfill" element={<ProtectedRoute><IndicationBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/asset-standardization" element={<ProtectedRoute><AssetStandardizationPage /></ProtectedRoute>} />
      <Route path="/data-ops/review-queue" element={<ProtectedRoute><ReviewQueuePage /></ProtectedRoute>} />
      <Route path="/data-ops/handshake-classifier" element={<ProtectedRoute><HandshakeClassifierPage /></ProtectedRoute>} />
      <Route path="/data-ops/deep-research-backfill" element={<ProtectedRoute><DeepResearchBackfillPage /></ProtectedRoute>} />
      <Route path="/data-ops/rerun-stale-mappings" element={<ProtectedRoute><StaleMappingsPage /></ProtectedRoute>} />
      <Route path="/data-ops/deck-reenrich" element={<ProtectedRoute><DeckReenrichPage /></ProtectedRoute>} />
      <Route path="/data-ops/suppressed-contacts" element={<ProtectedRoute><SuppressedContactsPage /></ProtectedRoute>} />
      <Route path="/data-ops/medtech-review" element={<ProtectedRoute><MedTechReviewPage /></ProtectedRoute>} />
      <Route path="/asset-imports/:tag" element={<ProtectedRoute><AssetImportPage /></ProtectedRoute>} />
      <Route path="/outreach/consolidate" element={<ProtectedRoute><ConsolidateOutreachPage /></ProtectedRoute>} />
      <Route path="/demo" element={<ProtectedRoute><DemoPage /></ProtectedRoute>} />
      <Route path="/admin/analytics" element={<ProtectedRoute><AdminOnly><AnalyticsPage /></AdminOnly></ProtectedRoute>} />
      <Route path="/investors" element={<ProtectedRoute><InvestorsPage /></ProtectedRoute>} />

      {/* Protected CRM pages */}
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/biotech" element={<ProtectedRoute><BiotechCompaniesPage /></ProtectedRoute>} />
      <Route path="/biotech/:id" element={<ProtectedRoute><CompanyDetailPage /></ProtectedRoute>} />
      {/* Jul 2026 · Out-licensing scope: Specialty (Formulation/Academic/
          DTx/Platform) list pages removed — legacy URLs land on /biotech.
          Company detail routes stay for old email/bookmark links. */}
      <Route path="/universities" element={<Navigate to="/biotech" replace />} />
      <Route path="/universities/:id" element={<ProtectedRoute><CompanyDetailPage /></ProtectedRoute>} />
      <Route path="/ndds" element={<Navigate to="/biotech" replace />} />
      <Route path="/ndds/:id" element={<ProtectedRoute><CompanyDetailPage /></ProtectedRoute>} />
      {/* /tail-assets kept as redirect for old bookmarks — tail assets are now regular assets */}
      <Route path="/tail-assets" element={<Navigate to="/assets" replace />} />
      <Route path="/dtx" element={<Navigate to="/biotech" replace />} />
      <Route path="/dtx/:id" element={<ProtectedRoute><CompanyDetailPage /></ProtectedRoute>} />
      <Route path="/biotech-contacts" element={<ProtectedRoute><BiotechContactsPage /></ProtectedRoute>} />
      <Route path="/pharma" element={<ProtectedRoute><PharmaContactsPage /></ProtectedRoute>} />
      <Route path="/admin/pharma-cleanup" element={<ProtectedRoute><DedupePharmaContactsPage /></ProtectedRoute>} />
      <Route path="/admin/recover-distributors" element={<ProtectedRoute><DistributorRecoveryPage /></ProtectedRoute>} />
      <Route path="/admin/verify-classifications" element={<ProtectedRoute><ClassificationVerifyPage /></ProtectedRoute>} />
      <Route path="/pharma/:id" element={<ProtectedRoute><PharmaContactDetailPage /></ProtectedRoute>} />
      <Route path="/deals" element={<ProtectedRoute><DealPipelinePage /></ProtectedRoute>} />
      <Route path="/financials" element={<ProtectedRoute><FinancialsPage /></ProtectedRoute>} />
      <Route path="/outreach" element={<ProtectedRoute><OutreachPage /></ProtectedRoute>} />
      <Route path="/assets" element={<ProtectedRoute><AssetsPage /></ProtectedRoute>} />
      <Route path="/company-profiles" element={<ProtectedRoute><CompanyProfilesPage /></ProtectedRoute>} />
      <Route path="/company-profile/:id" element={<ProtectedRoute><CompanyProfileDetailPage /></ProtectedRoute>} />
      <Route path="/ai-mapping" element={<ProtectedRoute><AIMappingPage /></ProtectedRoute>} />
      <Route path="/ai-mapping/:companyId" element={<ProtectedRoute><AIMappingPage /></ProtectedRoute>} />
      <Route path="/abacus" element={<ProtectedRoute><AbacusShortlistPage /></ProtectedRoute>} />
      <Route path="/alerts" element={<ProtectedRoute><AlertsPage /></ProtectedRoute>} />
      <Route path="/signals" element={<ProtectedRoute><AlertsPage /></ProtectedRoute>} />
      <Route path="/intelligence-hub" element={<ProtectedRoute><IntelligenceHubPage /></ProtectedRoute>} />
      <Route path="/copilot" element={<ProtectedRoute><CopilotPage /></ProtectedRoute>} />
      <Route path="/opportunity-lists" element={<ProtectedRoute><OpportunityListsPage /></ProtectedRoute>} />
      <Route path="/opportunity-lists/:id" element={<ProtectedRoute><OpportunityListsPage /></ProtectedRoute>} />
      <Route path="/campaigns" element={<ProtectedRoute><CampaignsPage /></ProtectedRoute>} />
      <Route path="/campaigns/:id" element={<ProtectedRoute><CampaignsPage /></ProtectedRoute>} />
      <Route path="/email-tracking" element={<ProtectedRoute><EmailTrackingPage /></ProtectedRoute>} />
      <Route path="/gmail" element={<ProtectedRoute><GmailPage /></ProtectedRoute>} />
      <Route path="/site-analytics" element={<ProtectedRoute><SiteAnalyticsPage /></ProtectedRoute>} />
      <Route path="/outreach-status" element={<ProtectedRoute><OutreachStatusPage /></ProtectedRoute>} />
      <Route path="/follow-ups" element={<ProtectedRoute><FollowUpsPage /></ProtectedRoute>} />
      <Route path="/follow-up-composer" element={<ProtectedRoute><FollowUpComposerPage /></ProtectedRoute>} />
      <Route path="/met-in-person" element={<ProtectedRoute><MetInPersonPage /></ProtectedRoute>} />
      <Route path="/weekly-digest" element={<ProtectedRoute><WeeklyDigestPage /></ProtectedRoute>} />
      <Route path="/portfolio-match" element={<ProtectedRoute><PortfolioMatchPage /></ProtectedRoute>} />
      <Route path="/accounts" element={<ProtectedRoute><AccountsPage /></ProtectedRoute>} />
      <Route path="/regional-distributors" element={<ProtectedRoute><RegionalDistributorsPage /></ProtectedRoute>} />
      <Route path="/accounts/:id" element={<ProtectedRoute><AccountDetailPage /></ProtectedRoute>} />
      <Route path="/clients" element={<ProtectedRoute><EngagementsListPage /></ProtectedRoute>} />
      <Route path="/clients/viatris" element={<ProtectedRoute><ViatrisWorkbenchPage /></ProtectedRoute>} />
      <Route path="/clients/modulus" element={<ProtectedRoute><ViatrisWorkbenchPage engagementId="eng-modulus-animal-health" clientLabel="Modulus" /></ProtectedRoute>} />
      {/* Jul 2026 — Animal Health Repositioning module. Isolated from
          Viatris/Modulus; own screening rules, templates, prompt parser. */}
      <Route path="/animal-health" element={<ProtectedRoute><AnimalHealthScreeningPage /></ProtectedRoute>} />
      <Route path="/animal-health/cohort" element={<ProtectedRoute><AnimalHealthCohortPage /></ProtectedRoute>} />
      <Route path="/animal-health/browse" element={<ProtectedRoute><AnimalHealthBrowsePage /></ProtectedRoute>} />
      <Route path="/animal-health/results" element={<ProtectedRoute><AnimalHealthResultsPage /></ProtectedRoute>} />
      <Route path="/admin/batch-errors" element={<ProtectedRoute><BatchErrorsPage /></ProtectedRoute>} />
      <Route path="/admin/funnel-debug" element={<ProtectedRoute><FunnelDebugPage /></ProtectedRoute>} />
      <Route path="/engagements" element={<ProtectedRoute><EngagementsListPage /></ProtectedRoute>} />
      {/* Feb 2026 · legacy redirect. `/engagements/:id` used to render
          the older, generic `EngagementDetailPage` — now superseded by
          the dedicated Viatris Workbench. For the sole current
          engagement (`eng-viatris-china`) redirect straight to the
          Workbench so any old bookmark / share link keeps working. */}
      <Route path="/engagements/:id" element={<Navigate to="/clients/viatris?cohort=Cohort+1" replace />} />
      {/* Legacy redirect */}
      <Route path="/india-licensing" element={<Navigate to="/accounts" replace />} />
      <Route path="/india-licensing/:id" element={<Navigate to="/accounts" replace />} />
      <Route path="/contact-matching" element={<ProtectedRoute><ContactMatchingPage /></ProtectedRoute>} />
      <Route path="/db-sync" element={<ProtectedRoute><DatabaseSyncPage /></ProtectedRoute>} />
      <Route path="/imports/:tag" element={<ProtectedRoute><ConferenceImportPage /></ProtectedRoute>} />
      <Route path="/imports" element={<ProtectedRoute><ImportHubPage /></ProtectedRoute>} />
      <Route path="/inbox" element={<ProtectedRoute><InboxTriagePage /></ProtectedRoute>} />
      <Route path="/audit" element={<ProtectedRoute><AuditPage /></ProtectedRoute>} />
      <Route path="/duplicates" element={<ProtectedRoute><DuplicatesInspectorPage /></ProtectedRoute>} />
      <Route path="/merge-recovery" element={<ProtectedRoute><MergeRecoveryPage /></ProtectedRoute>} />
      <Route path="/email-coverage" element={<ProtectedRoute><EmailCoveragePage /></ProtectedRoute>} />
      <Route path="/review" element={<ReviewerRoute><ReviewerWorkspace /></ReviewerRoute>} />
      <Route path="*" element={<CatchAllRedirect />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <RouteTracker />
        <AppRouter />
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
